var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%"}},[_c('h2',[_vm._v(" Not Found 404 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }